import * as types from './mutations-types'

export default {
  [types.CONSUMED_COUPON_INFO] (state, data) {
    let compare = function () {
      return function (objAfter, objBefore) {
        let val1 = objAfter['id']
        let val2 = objBefore['id']
        return val2 - val1
      }
    }
    state.consumedCouponInfo = data.sort(compare())
  },
  [types.UPDATE_COUPON_INFO_RECORD] (state, data) {
    state.consumedCouponInfo = state.consumedCouponInfo.map(item => {
      if (item.id === data.id) {
        item.state = true
      }
      return item
    })
  },
  [types.UPDATE_COUPON_INFO_FALSE_RECORD] (state, data) {
    state.consumedCouponInfo = state.consumedCouponInfo.map(item => {
      if (item.id === data.id) {
        item.state = false
      }
      return item
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-consuming-records/store/mutations.js